import { render, staticRenderFns } from "./SettingAudienceAuthentication.vue?vue&type=template&id=09bf7064&scoped=true&"
import script from "./SettingAudienceAuthentication.vue?vue&type=script&lang=js&"
export * from "./SettingAudienceAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./SettingAudienceAuthentication.vue?vue&type=style&index=0&id=09bf7064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf7064",
  null
  
)

export default component.exports